import { FormattedMessage } from 'react-intl';
import { useNavigate, useNavigationType } from 'react-router-dom';

import { ArrowBack } from '../../../design-system/Icons/ArrowBack';
import s from '../../../shared/components/layout/ContextualNavbar.module.css';
import { DEFAULT_VIEW_ROUTE } from '../../../shared/routing/RequestManagerRoutes';

export const MessageTemplateNavbar = (): JSX.Element => {
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const hasNavigatedInRequestManager = navigationType !== 'POP';
    return (
        <nav className={s.navbarContainer}>
            <div className={s.backContainer}>
                <a
                    data-testid="message-templates-navbar-back"
                    onClick={() =>
                        hasNavigatedInRequestManager ? navigate(-1) : navigate(DEFAULT_VIEW_ROUTE)
                    }
                    className={s.backButton}
                >
                    <ArrowBack color="var(--ink)" fontSize="small" />
                    <p className={s.backLabel}>
                        <FormattedMessage id="global.back" />
                    </p>
                </a>
            </div>
        </nav>
    );
};
